// extracted by mini-css-extract-plugin
export default {"form":"ChangePassword_form__pcrmA","error":"ChangePassword_error__jFxbs","actions":"ChangePassword_actions__gYX2f"};